import { IconProps } from '.';

const OneIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142894)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 37.5C29.665 37.5 37.5 29.665 37.5 20C37.5 10.335 29.665 2.5 20 2.5C10.335 2.5 2.5 10.335 2.5 20C2.5 29.665 10.335 37.5 20 37.5ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
        <path
          d="M20.0752 28.3334V12.1583L20.3002 10.8333H22.4752V28.3334H20.0752ZM16.2002 15.6084V13.3833C16.5669 13.4 16.9919 13.2834 17.4752 13.0333C17.9752 12.7833 18.4752 12.4583 18.9752 12.0584C19.4752 11.6584 19.9169 11.2417 20.3002 10.8083L21.8252 12.4583C21.2585 13.0583 20.6669 13.6 20.0502 14.0833C19.4335 14.5667 18.8002 14.95 18.1502 15.2333C17.5169 15.5167 16.8669 15.6417 16.2002 15.6084Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142894">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OneIcon;
